




































import {Component, Watch, Vue} from 'vue-property-decorator';
import {cloneDeep, isEqual} from 'lodash';
import {mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';
import EquipmentTable from '@/components/specific/EquipmentsTable/EquipmentTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';

@Component({
    components: {CSelect, EquipmentTable},
    computed: {
        ...mapState('planEdit', ['planEdit']),
    },
})
export default class PlanEquipmentSettings extends Vue {
    private idSettingsEquipment: number | null = null;
    private loading: boolean = false;
    private editing: boolean = false;
    private initialData: any = null;
    private data: any = null;
    public planEdit!: PlanEditModel | null;

    get hasUnsavedChanges() {
        return !isEqual(this.data, this.initialData);
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    get idPlan() {
        return this.planEdit?.Id;
    }

    @Watch('hasUnsavedChanges')
    onHasUnsavedChangesChange(value: boolean) {
        this.$root.$emit('plan_edit:unsaved_changes', value);
    }

    @Watch('editing')
    onEditingChange(value: boolean) {
        this.$emit('tab-edit', value);
    }

    created() {
        this.$root.$on('plan_edit:unsaved_changes:reset', this.onCancel);
        this.getData();
    }

    beforeDestroy() {
        this.$root.$off('plan_edit:unsaved_changes:reset', this.onCancel);
    }

    async getData() {
        const timerId = setTimeout(() => (this.loading = true), 150);
        try {
            const {data} = await this.getEditModel();
            this.data = data;
            this.initialData = cloneDeep(this.data);
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
    getEditModel() {
        return this.$http.get(`${this.$api.journals.planEquipment}/GetEdit`, {
            params: {
                idPlan: this.idPlan,
            },
        });
    }

    async onLoadTemplate() {
        if (this.idSettingsEquipment === null) return;
        const timerId = setTimeout(() => (this.loading = true), 150);
        try {
            const {data} = await this.$http.get(`${this.$api.catalogues.settingsEquipment}/GetEdit`, {
                params: {
                    id: this.idSettingsEquipment,
                },
            });
            this.data = data.ElementList;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
    async onSave() {
        if (!this.validate()) return;
        const timerId = setTimeout(() => (this.loading = true), 150);
        try {
            const {data} = await this.$http.post(`${this.$api.journals.planEquipment}/Save`, this.data, {
                params: {
                    idPlan: +this.$route.params.idPlan,
                },
            });
            this.data = data;
            this.initialData = cloneDeep(this.data);
            this.editing = false;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
    onCancel() {
        this.data = cloneDeep(this.initialData);
        this.editing = false;
    }
    validate() {
        return (this.$refs['main-form'] as any).validate();
    }
}
